import React, { useState } from "react";
import img1 from "../img/img1.png";
import img2 from "../img/img2.png";
import img3 from "../img/img3.png";
import hue from "../img/den/hue.png";
import taybac from "../img/den/taybac.png";
import taynguyen from "../img/den/taynguyen.png";
import td1 from "../img/td1.jpg";

const BestSeller = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const products = [
    {
      img: hue,
      alt: "Đèn xông tinh dầu cao cấp",
      name: "Đèn xông tinh dầu cao cấp 200ml - Nét Tím Mộng Mơ Cố Đô Huế",
      benefit: "THƯ GIÃN SÂU & CÂN BẰNG TINH THẦN",
      currentPrice: "Comming Soon",
      oldPrice: "650,000 ₫",
    },
    {
      img: taybac,
      alt: "Tinh dầu thiên nhiên 50ml - Hương Sắc Tây Bắc, Xua Tan Muộn Phiền",
      name: "Tinh dầu thiên nhiên 50ml - Hương Sắc Tây Bắc, Xua Tan Muộn Phiền",
      benefit: "LÀM SẠCH KHÔNG KHÍ & TĂNG CƯỜNG SỨC KHỎE",
      currentPrice: "Comming Soon",
      oldPrice: "480,000 ₫",
      gift: true,
    },
    {
      img: td1,
      alt: "Tinh dầu thiên nhiên 100ml",
      name: "Tinh dầu thiên nhiên 100ml",
      benefit: "THƯ GIÃN SÂU & CÂN BẰNG TINH THẦN",
      currentPrice: "Comming Soon",
      oldPrice: "300,000 ₫",
    },
    // Thêm sản phẩm nếu cần, carousel sẽ tự động xử lý
  ];
  const visibleProducts = 3;
  const totalSlides = Math.ceil(products.length / visibleProducts);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  return (
    <section id="bestseller" className="section bestseller">
      <div className="bestseller-container">
        <div className="bestseller-content">
          <div className="bestseller-text">
            <h2 className="bestseller-title">
              <span className="bestseller-subtitle">Sản phẩm</span>
              <span className="bestseller-main-title">BÁN CHẠY</span>
            </h2>
            <p className="bestseller-description">
              <em>
                Memory Lamp tự hào rằng những sản phẩm chúng tôi tạo ra mang đến
                những thay đổi tuyệt vời cho không gian sống và sức khỏe tinh
                thần của bạn.
              </em>
            </p>
          </div>
        </div>
        <div className="bestseller-products">
          <div
            className="product-carousel"
            style={{
              transform: `translateX(-${(currentIndex * 100) / visibleProducts}%)`,
            }}
          >
            {products.map((product, index) => (
              <div key={index} className="product-card-bestseller">
                <div className="product-image-container">
                  <img
                    src={product.img}
                    alt={product.alt}
                    className="product-image-bestseller"
                  />
                </div>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-benefit">{product.benefit}</p>
                <div className="product-price">
                  <span className="current-price" style={{color: '#FF0000', fontSize: '14px' }}>{product.currentPrice}</span>
                  {product.oldPrice && (
                    <span className="old-price">{product.oldPrice}</span>
                  )}
                </div>
                {/* <button className="add-to-cart-btn">
                  <span className="cart-icon">🛒</span>
                </button> */}
              </div>
            ))}
          </div>
          {totalSlides > 1 && (
            <>
              <button
                className="carousel-nav-btn prev-btn"
                onClick={prevSlide}
                aria-label="Previous"
              >
                ‹
              </button>
              <button
                className="carousel-nav-btn next-btn"
                onClick={nextSlide}
                aria-label="Next"
              >
                ›
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default BestSeller;